export default "__VITE_ASSET__Dgg$uj$S__"